<template>
  <div>
    <search-bar v-if="!tableOnly" @search="doSearch" @clear="doClear" :full-width="true" :query="mode.search.q" :doing="mode.search.doing"></search-bar>
    <panel :title="(!uncover && (title || 'Projects'))" :footerShow="true" :class="{'uncovered-panel': uncover}">
      <div slot="headingElements" v-show="_can('createProject') && !tableOnly">
        <a class="btn btn-success" @click="addItemClick()"><i class="icon-add"></i> <span class="text-semibold">Add project</span></a>
      </div>
      <div>
        <div ref="list" class="datatable-scroll scrollable">
        <!-- Agent view -->
        <table class="dataTable table table-togglable table-hover default footable tasks-list text-nowrap" role="grid">
          <thead>
          <tr role="row">
            <th v-if="!tableOnly" tabindex="0" rowspan="1" colspan="1" data-sort-field="id" @click.prevent="toggleSort" style="width: 20px;"></th>
            <th tabindex="0" rowspan="1" colspan="1" data-sort-field="name" @click.prevent="toggleSort">Name</th>
            <th tabindex="0" rowspan="1" colspan="1" data-sort-field="address" @click.prevent="toggleSort" data-hide="phone,tablet">Address</th>
            <th tabindex="0" rowspan="1" colspan="1" data-sort-field="yield" @click.prevent="toggleSort" data-hide="phone,tablet">Yield %</th>
            <th v-if="(_is('superAdmin') || _is('agencyAdmin')) && !tableOnly && active" tabindex="0" rowspan="1" colspan="1" style="width: 1%;">Access
              <button class="btn btn-sm label btn-success ml-10 float-right" @click.prevent="grandAccessSave()">Apply</button>
            </th>
            <th tabindex="0" rowspan="1" colspan="1" class="text-center" data-hide="phone">Apartments<br/><span class="text-muted text-size-small">Total / Reserved / Sold</span></th>
            <th v-if="_can('readProject') || _can('updateProject') || _can('deleteProject')" tabindex="0" rowspan="1" colspan="1" class="text-center"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="!items.length" class="active border-double">
            <td :colspan="_can('superAdmin') ? 8 : 7" class="text-semibold text-center">No data available</td>
          </tr>
          <tr @click="tryEditItem(item.id)" class="border-top-dashed-2px" v-for="(item, idx) in items" :key="item.id" role="row" v-bind:class="{'even': idx === 0 || idx % 2 === 0, 'odd': idx % 2, 'cursor-pointer': tableOnly}">
            <td>
              <div class="text-semibold" style="cursor: pointer" @click.prevent="editItem(item.id)">
                <img v-if="item.logo && item.status === 1" :src="item.logo.preview" style="max-height: 48px; max-width: 80px;" :alt="item.name">
                <img v-else :src="require('@/assets/images/logo.png')" style="max-height: 48px; max-width: 80px;" :alt="item.name">
              </div>
            </td>
            <td>
              <div class="text-semibold"><a href="#" @click.prevent="editItem(item.id)">{{item.name}}</a></div>
            </td>
            <td>
              <div class="text-semibold">{{item.address}}</div>
            </td>
            <td>
              <div class="text-semibold">{{ ((item.totalRent / item.totalPrice)*100).toFixed(2) }}</div>
            </td>
            <td v-if="(_is('superAdmin') || _is('agencyAdmin')) && !tableOnly && active" style="min-width: 150px;">
              <div v-if="!item.is_public">
                <multi-select
                  v-model="itemSelected[item.id]"
                  :options="{multi: true, labelSelected: 'access'}"
                  :selectOptions="item.accessItems"
                  :btnLabel="'Granted agencies'"
                ></multi-select>
                <!-- button class="btn btn-sm btn-success" @click.prevent="grantRejectAccess(item.id, true)">Apply</button -->
              </div>
            </td>
            <td>
              <div class="text-semibold text-center">
                {{item.totalApartments}} / {{item.reservedApartments}} / {{item.soldApartments}}
              </div>
            </td>
            <td>
              <ul class="icons-list">
                <li v-if="_can('readProject') && !_can('updateProject')"><a href="#" @click.prevent="editItem(item.id)" title="See details"><i class="icon-eye"></i></a></li>
                <li v-if="_can('updateProject')"><a href="#" @click.prevent="editItem(item.id)" title="Update project"><i class="icon-pencil"></i></a></li>
                <li v-if="_can('deleteProject')"><a v-if="!tableOnly" href="#" @click.prevent="deleteItem(item.id)" title="Delete project"><i class="icon-trash"></i></a></li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>
        </div>
        <div slot="footerElements" v-if="!tableOnly">
          <div class="col-sm-12">
            <pagination :page="paging.page" :itemsPerPage="paging.perPage" :maxVisiblePage="5" :totalItems="paging.total" @page-change="__pageChanged"/>
          </div>
        </div>
      </div>
    </panel>
    <overlay v-if="showLoader" message="Please wait..." html="<i class='icon-spinner2 icon-2x spinner'></i>"></overlay>
  </div>
</template>

<script>

import Vue from 'vue'

import ProjectService from '@/services/project.service'
import listMixin from '@/helpers/mixins/_listMixin'
import SearchBar from '@/components/_partial/search-bar'

export default {
  components: { SearchBar },
  name: 'ProjectList',
  mixins: [listMixin],

  props: {
    'tableOnly': {
      type: Boolean,
      default: false
    },
    'uncover': {
      type: Boolean,
      default: false
    },
    'active': {
      type: Boolean,
      default: true
    },
    'title': {
      type: String
    }
  },

  data () {
    return {
      id: null,
      itemTemplate: {
        showModal: false
      },
      mode: {
        search: {
          filter: {
            'status': this.active ? 1 : 2
          }
        }
      },
      itemSelected: {},
      service: ProjectService
    }
  },

  beforeMount () {
  },

  mounted () {
  },

  methods: {
    redoSelection (itemId = null, result = null) {
      if (itemId === null && result === null) {
        this.itemsSelected = {}
        for (let idx in this.items) {
          if (Array.isArray(this.items[idx].accessItems)) {
            this.itemSelected[this.items[idx].id] = this.items[idx].accessItems.filter(item => parseInt(item.access) > 0)
          }
        }
      } else {
        for (let idx in this.items) {
          if (this.items[idx].id === itemId) {
            this.items[idx].accessItems = result
            if (Array.isArray(this.items[idx].accessItems)) {
              this.itemSelected[itemId] = this.items[idx].accessItems.filter(item => parseInt(item.access) > 0)
            }
          }
        }
      }
    },

    onListReceive () {
      this.redoSelection()
    },

    grandAccessSave () {
      let promises = []
      for (let i in this.items.filter(p => !p.is_public)) {
        promises.push(this.grantRejectAccess(this.items[i].id, false))
      }
      Promise.all(promises).then(() => {
        this.$popup.success('Projects access saved successfully')
      })
    },

    grantRejectAccess (itemId, showPopup = false) {
      let data = this.items.filter(item => parseInt(item.id) === parseInt(itemId))[0].accessItems
      let selected = this.itemSelected[itemId]
      for (let i in data) {
        data[i].access = 0
        for (let j in selected) {
          if (parseInt(selected[j].id) === parseInt(data[i].id)) {
            data[i].access = 1
          }
        }
      }
      this.items.filter(item => parseInt(item.id) === parseInt(itemId))[0].accessItems = data
      return this.service.setAccess(itemId, data, (result) => {
        this.redoSelection(itemId, result)
        if (showPopup) {
          this.$popup.success('Project access saved successfully')
        }
      })
    },

    reset (forceItemsReset = true) {
      this.id = null
      this.groupStatuses = Vue.config.statusGroups['po'] ? Vue.config.statusGroups['po'] : Vue.config.statusGroups['*']
      for (let i = 0; i < this.groupStatuses.length; i++) {
        this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
      }
    },

    tryEditItem (id) {
      if (this.tableOnly) {
        this.editItem(id)
      }
    },

    editItem (id) {
      this.$router.push('project/details/' + id)
    },

    deleteItem (id) {
      this.$popup.confirm('Are you sure you want to remove this project?', 'Project delete').then(() => {
        this.service.drop(id, (result) => {
          this.refresh()
        })
      })
    },

    updateItemRow (i) {
      this.service.item(i.id, result => {
        i.status = result.status
        i.updated_at = result.updated_at
      })
    },

    addItemClick () {
      this.$router.push('project/add')
    },

    canBeChanged (object) {
      let result = typeof object === 'object'
      if (result) {
        result = result && object.hasOwnProperty('id') && object.id
      }
      result = result && object.status === 1
      return result
    }
  }
}
</script>

<style scoped src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.uncovered-panel.panel {
    border: none !important;
}
.uncovered-panel.panel .panel-body {
  padding: 0 !important;
  margin: 0 !important;
}

</style>
